import { PlatformPage } from './PlatformPage'
import { DbToolsTab } from './tabs/DbToolsTab'

export function DbToolsPage() {
  return (
    <PlatformPage
      title="Database Tools"
      description="Run maintenance queries, inspect schema, and export snapshots."
    >
      <DbToolsTab />
    </PlatformPage>
  )
}
